<div id="global-loader">
    <img src="./assets/images/loader.svg" class="loader-img" alt="Loader" />
  </div>
  <div class="page main-signin-wrapper">
    <section class="signup__area po-rel-z1 pt-100 pb-145">
      <div class="container shapes-div">
        <div class="row">
          <div class="sign__shape">
            <img src="assets/images/man-1.png" alt="" class="man-1" />
            <img src="assets/images/man-2.png" alt="" class="man-2" />
            <img src="assets/images/circle.png" alt="" class="circle" />
            <img src="assets/images/zigzag.png" alt="" class="zigzag" />
            <img src="assets/images/dot.png" alt="" class="dot" />
            <img src="assets/images/sign-up.png" alt="" class="bg" />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-xl-8 offset-xl-2">
            <div class="section__title-wrapper text-center mb-5">
              <h2 class="section__title">Sign In</h2>
              <!-- <p>If You Don't Have An Account You Can Register Here!</p> -->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
            <div class="sign__wrapper white-bg">
              <div class="sign__header mb-5">
                <div class="sign__in text-center">
                  <h2>Certificate Login</h2>
                  <!-- <ul class="social-media-icons">
                    <li>
                      <a href="#" class="sign__social ml-2">
                        <i class="fa fa-facebook-f"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" class="sign__social ml-2">
                        <i class="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#" class="sign__social ml-2">
                        <i class="fa fa-youtube"></i>
                      </a>
                    </li>
                  </ul> -->
                </div>
              </div>
              <div class="sign__form">
                <form [formGroup]="CertLoginForm" novalidate>
                  <div class="sign__input-wrapper mb-4">
                    <h5>User Id/Mobile No.</h5>
                    <div class="sign__input">
                      <input required
                        type="text"  onkeydown="return (event.keyCode!=13);"
                        formControlName="LoginName"
                        id="LoginName"
                        placeholder="User Id" maxlength="10"
                      />
                      <i class="fa fa-envelope"></i>
                    </div>
                    <mat-error class="margin_tp"
                    *ngIf="CertLoginForm.controls['LoginName'].touched && CertLoginForm.controls['LoginName'].errors?.required">
                    Mandatory.
                </mat-error>
                  </div>
                  <div class="sign__input-wrapper mb-4">
                    <h5>Password</h5>
                    <div class="sign__input">
                      <!-- <input type="text" placeholder="Password"  formControlName="LoginPswd" class="form-control pe-5 password-input" id="LoginPswd">
                        <i class="fa fa-lock"></i> -->
                      <input name="password" [type]="showPassword ? 'text' : 'password'" class="form-control pwd-control" 
                        id="password-field"  onkeydown="return (event.keyCode!=13);" placeholder="Password" formControlName="LoginPswd">
                      <i class="fa fa-lock"></i>
                      <i alt="show" class="fa fa-eye-slash eyeeee" (click)="showPassword = !showPassword" [class.hide]="showPassword"></i>
                      <i alt="hide" class="fa fa-eye eyeeee" (click)="showPassword = !showPassword" [class.hide]="!showPassword"></i>
                    </div>
                    <mat-error class="margin_tp"
                    *ngIf="CertLoginForm.controls['LoginPswd'].touched && CertLoginForm.controls['LoginPswd'].errors?.required">
                    Mandatory.
                </mat-error>
                  </div>
                  <div
                    class="sign__action d-sm-flex justify-content-between mb-4"
                  >
                    <div class="sign__agree d-flex align-items-center">
                      <!-- <input type="checkbox" id="m-agree" class="m-check-input" />
                      <label for="m-agree" class="m-check-label"
                        >Keep me signed in
                      </label> -->
                    </div>
                    <div class="sign__forgot">
                      <a (click)="ForgotPass()">Forgot your password?</a>
                    </div>
                  </div>
                  <button class="e-btn w-100 colfff" type="submit" (click)="Login()">Sign In</button>
                  <div class="sign__new text-center mt-3">
                    <p> <a  (click)="SignUp()">New to here? Sign Up</a></p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  